export default __webpack_public_path__ + "c3bd605e4c25b2a2b378ed47449d3f84.svg";